

















import Vue from 'vue'
import { Component } from '@niknevis/vue-modules'
import { Prop } from 'vue-property-decorator'
import MessageBoardCarousel from '@/modules/common/message-board/components/panel/MessageBoardCarousel.vue'

export interface DashboardCardItemModel {
  label: string,
  value: number,
  icon: string,
  url?: string,
  color?: string
}

@Component({
  components: { MessageBoardCarousel }
})
export default class DashboardCard extends Vue {
  @Prop() item!: DashboardCardItemModel
}
